<div class="contact-wrapper">
  <form [formGroup]="editContactForm" class="contact-form">
    <div class="form-item name">
      <label class="form-label required" i18n="@@contact.name">Name</label>
      <div class="input-wrapper">
        <input type="text" formControlName="name" class="form-control" />
        <span
          *ngIf="
            (editContactForm.get('name').touched ||
              editContactForm.get('name').dirty) &&
            editContactForm.get('name').errors
          "
          class="invalid-feedback"
        >
          <span
            *ngIf="editContactForm.get('name').errors.required"
            i18n="@@validation.name.required"
            >Please enter a name.</span
          >
        </span>
      </div>
    </div>

    <div class="form-item phone">
      <label class="form-label" i18n="@@contact.phone">Phone number</label>
      <div class="input-wrapper">
        <input type="tel" formControlName="phone" class="form-control" />
        <span
          *ngIf="
            (editContactForm.get('phone').touched ||
              editContactForm.get('phone').dirty) &&
            editContactForm.get('phone').errors
          "
          class="invalid-feedback"
        >
          <span
            *ngIf="editContactForm.get('phone').errors.pattern"
            i18n="@@validation.phone.invalid"
            >Please enter a correct phone nr.</span
          >
        </span>
      </div>
    </div>

    <div class="form-item email">
      <label class="form-label" i18n="@@contact.email">Email</label>
      <div class="input-wrapper">
        <input type="text" formControlName="email" class="form-control" />
        <span
          *ngIf="
            (editContactForm.get('email').touched ||
              editContactForm.get('email').dirty) &&
            editContactForm.get('email').errors
          "
          class="invalid-feedback"
        >
          <span
            *ngIf="editContactForm.get('email').errors.pattern"
            i18n="@@validation.email.invalid"
            >Please enter a correct email.</span
          >
        </span>
      </div>
    </div>

    <div class="form-item lang">
      <label class="form-label required" i18n="@@contact.language"
        >Language</label
      >
      <div class="input-wrapper">
        <p-dropdown
          [options]="languageOptions"
          formControlName="language"
          optionLabel="label"
          optionValue="value"
          placeholder="_"
        ></p-dropdown>
        <span
          *ngIf="
            (editContactForm.get('language').touched ||
              editContactForm.get('language').dirty) &&
            editContactForm.get('language').errors
          "
          class="invalid-feedback"
        >
          <span
            *ngIf="editContactForm.get('language').errors.required"
            i18n="@@validation.language.required"
            >Language can not be empty.</span
          >
          <span
            *ngIf="editContactForm.get('language').errors.pattern"
            i18n="@@validation.language.invalid"
            >Please enter a correct language.</span
          >
        </span>
        <span
          *ngIf="
            (editContactForm.get('personType').touched ||
              editContactForm.get('personType').dirty) &&
            editContactForm.get('personType').errors
          "
          class="invalid-feedback"
        >
          <span
            *ngIf="editContactForm.get('personType').errors.required"
            i18n="@@validation.role.required"
            >Role can not be empty.</span
          >
        </span>
      </div>
    </div>

    <div class="form-item role">
      <label class="form-label required" i18n="@@contact.role">Role</label>
      <div class="input-wrapper">
        <p-dropdown
          [options]="roleOptions"
          formControlName="personType"
          optionLabel="label"
          optionValue="value"
          placeholder="_"
        ></p-dropdown>
      </div>
    </div>

    <ng-container formGroupName="address">
      <div class="form-item street">
        <label class="form-label required"
          ><ng-container i18n="@@contact.street">Street</ng-container
          >&nbsp;<span class=""></span
        ></label>
        <div class="input-wrapper">
          <input type="text" formControlName="street" class="form-control" />
          <span
            *ngIf="
              (editContactForm.get('address').get('street').touched ||
                editContactForm.get('address').get('street').dirty) &&
              editContactForm.get('address').get('street').errors
            "
            class="invalid-feedback"
          >
            <span
              *ngIf="
                editContactForm.get('address').get('street').errors.required
              "
              i18n="@@validation.street.required"
              >Please enter an street.</span
            >
          </span>
          <span
            *ngIf="
              (editContactForm.get('address').get('number').touched ||
                editContactForm.get('address').get('number').dirty) &&
              editContactForm.get('address').get('number').errors
            "
            class="invalid-feedback"
          >
            <span
              *ngIf="
                editContactForm.get('address').get('number').errors.required
              "
              i18n="@@validation.housenumber.required"
              >Please enter an number.</span
            >
            <span
              *ngIf="
                editContactForm.get('address').get('number').errors.pattern
              "
              i18n="@@validation.housenumber.invalid"
              >House nr must be a number.</span
            >
          </span>
          <span
            *ngIf="
              (editContactForm.get('address').get('suffix').touched ||
              editContactForm.get('address').get('suffix').dirty) &&
              editContactForm.get('address').get('suffix').errors
            "
            class="invalid-feedback"
          >
            <span
              *ngIf="editContactForm.get('address').get('suffix').errors.validateThreeAlphabeticCharacters"
              i18n="@@validation.housesuffix.threealphabeticcharacters.invalid"
              >House suffix can have a maximum of 3 alphabetic characters.</span
            >
            <span
              *ngIf="editContactForm.get('address').get('suffix').errors.validateThreeNumericCharacters"
              i18n="@@validation.housesuffix.theenumericcharacters.invalid"
              >House suffix can have a maximum of 3 numeric characters.</span
            >
            <span
              *ngIf="editContactForm.get('address').get('suffix').errors.validateOneAlphabeticAndThreeNumericCharacters"
              i18n="@@validation.housesuffix.onealphathreenumeric.invalid"
              >House suffix can have 1 alphabetic character followed by maximum 3 numeric characters.</span>            
          </span>
        </div>
      </div>

      <div class="form-item house-nr">
        <label class="form-label required"
          ><ng-container i18n="@@contact.housenumber.short">nr.</ng-container
          >&nbsp;<span class=""></span
        ></label>
        <div class="input-wrapper">
          <input type="number" formControlName="number" class="form-control" />
        </div>
      </div>

      <div class="form-item suffix">
        <label class="form-label" i18n="@@contact.suffix">Suffix</label>
        <div class="input-wrapper">
          <input type="text" formControlName="suffix" class="form-control" oninput="this.value = this.value.toUpperCase()" />          
        </div>
      </div>

      <div class="form-item postal-code">
        <label class="form-label required" i18n="@@contact.postalcode"
          >Postal code</label
        >
        <div class="input-wrapper">
          <input
            type="number"
            formControlName="postalCode"
            class="form-control"
          />
          <span
            *ngIf="
              (editContactForm.get('address').get('postalCode').touched ||
                editContactForm.get('address').get('postalCode').dirty) &&
              editContactForm.get('address').get('postalCode').errors
            "
            class="invalid-feedback"
          >
            <span
              *ngIf="
                editContactForm.get('address').get('postalCode').errors.required
              "
              i18n="@@validation.postalcode.required"
              >Please enter an postal code.</span
            >
            <span
              *ngIf="
                editContactForm.get('address').get('postalCode').errors.pattern
              "
              i18n="@@validation.postalcode.invalid"
              >Please enter a correct postal code.</span
            >
          </span>
          <span
            *ngIf="
              (editContactForm.get('address').get('city').touched ||
                editContactForm.get('address').get('city').dirty) &&
              editContactForm.get('address').get('city').errors
            "
            class="invalid-feedback"
          >
            <span
              *ngIf="editContactForm.get('address').get('city').errors.required"
              i18n="@@validation.city.required"
              >Please enter a city.</span
            >
          </span>
        </div>
      </div>

      <div class="form-item city">
        <label class="form-label required" i18n="@@contact.city">City</label>
        <div class="input-wrapper">
          <input type="text" formControlName="city" class="form-control" />
        </div>
      </div>
    </ng-container>
  </form>
</div>
